import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { PropsWithChildren, ReactElement } from "react";
import "./Modal.css";
import Button from "../Button/Button";

interface ModalProps extends PropsWithChildren {
    title?: string,
    onCloseModal?: React.MouseEventHandler,
    class?: string
}
function Modal(props: ModalProps): ReactElement {
    return (
        <div className="modal-bg">
            <div className="modal-container">
                <div className="modal-header">
                    <span className="modal-title">{props?.title}</span>
                    {props.onCloseModal && <div className="close-btn">
                        <Button forceEnabled={true} type="cancel" ariaLabel="cancel"
                            onClick={(e) => {
                                if (props.onCloseModal) {
                                    props.onCloseModal(e)
                                }
                            }}>
                            <FontAwesomeIcon icon={faClose} />
                        </Button>
                    </div>}
                </div>
                <div className={"modal-body" + (props.class ? " " + props.class : "")}>
                    {props.children}
                </div>
            </div>
        </div>
    );
}

export default Modal;